import Navbar from './components/Navbar';
import Hero from './components/Hero';
import About from './components/About';
import ISOCertification from './components/ISOCertification';
import ISOEducation from './components/ISOEducation';
import ManagementCertification from './components/ManagementCertification';
import OtherCertification from './components/OtherCertification';
import Consulting from './components/Consulting';
import Contact from './components/Contact';
import Footer from './components/Footer';

export default function HomePage() {
  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      <Hero />
      <About />
      <ISOCertification />
      <ISOEducation />
      <ManagementCertification />
      <OtherCertification />
      <Consulting />
      <Contact />
      <Footer />
    </div>
  );
}
